import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faThumbtack, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { errorToastr, successToastr } from "../../../HelperMethods";
import Skeleton from "react-loading-skeleton";
import { ErrorComponent } from "../../ReusableComponents";
import { PostReportSearch, UpdateReportSearch } from "../Services/DataServices";
import { REPORT_SEARCH_BLANK_PARAMETER_MSG, REPORT_SEARCH_CREATED_SUCCESS_MSG, REPORT_SEARCH_UPDATED_SUCCESS_MSG } from "../../Shared/AppMessages";

export interface CreateNewReportSearchProps {
    onCloseModal: any;
    onOpenModal: any;
    getSavedReportSearches: Function;
    reportName: any;
    reportId: any;
    filterName: string;
    isPinned: string;
    reportSearchId: any;
    showCreateModal: Function;
}

export interface CreateNewReportSearchState {
    filterName?: any;
    isPinned?: any;
    isSubmitted?: any;
    showLoader?: any;
}
class CreateNewReportSearch extends React.Component<CreateNewReportSearchProps, CreateNewReportSearchState> {
    constructor(props: CreateNewReportSearchProps) {
        super(props);
        this.state = {
            showLoader: false,
            isPinned: false
        };
    }
    componentDidMount() {
        this.setState({ isPinned: this.props.isPinned, filterName: this.props.filterName });
    }

    handleSaveAndClose = () => {
        this.setState({ isSubmitted: true });

        if ((this.state.filterName.trim() == undefined || this.state.filterName.trim() == null || this.state.filterName.trim() == "")) {
            return false;
        }

        let clientReportSource = JSON.parse(sessionStorage.getItem("#_state"));

        if ((clientReportSource == undefined || clientReportSource == null || clientReportSource == "")) {
            errorToastr(REPORT_SEARCH_BLANK_PARAMETER_MSG);
            return false;
        }

        if (this.props.reportSearchId) {

            let data = {
                reportSearchId: this.props.reportSearchId,
                name: this.state.filterName.trim(),
                reportName: this.props.reportName,
                //reportId: this.props.reportId, Todo:
                pinned: this.state.isPinned,
                filter: JSON.stringify(clientReportSource)
            };

            UpdateReportSearch(data)
                .then((res) => {
                    successToastr(REPORT_SEARCH_UPDATED_SUCCESS_MSG);
                    this.setState({ isSubmitted: false, showLoader: false });
                    this.props.showCreateModal();
                    this.props.getSavedReportSearches(this.props.reportName, data.reportSearchId);
                });
        } else {

            let data = {
                name: this.state.filterName,
                reportName: this.props.reportName,
                //reportId: this.props.reportId, Todo:
                pinned: this.state.isPinned,
                filter: JSON.stringify(clientReportSource)
            };

            PostReportSearch(data)
                .then((res) => {
                    successToastr(REPORT_SEARCH_CREATED_SUCCESS_MSG);
                    this.setState({ isSubmitted: false, showLoader: false });
                    this.props.showCreateModal();
                    this.props.getSavedReportSearches(this.props.reportName);
                });
        }
    }

    render() {
        const { filterName, isPinned } = this.state;
        return (
            <div id="add-ReportingFilter" className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            Save Filter
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 1 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 1 }).map((item, j) => (
                                    <div className="col-12 col-sm-12 col-lg-12 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div className="model-body ">
                            <div className="row mt-3 mx-0">
                                <div className="text-center col-sm-11 mt-1 mt-sm-0 pl-4">
                                    <label className="pl-4 text-center mb-0 font-weight-bold required">Filter Name</label>
                                    <input
                                        type="text"
                                        className="form-control mt-1"
                                        placeholder="Enter Filter Name"
                                        required={true}
                                        value={filterName}
                                        maxLength={100}
                                        onChange={(event) => {
                                            this.setState({ filterName: event.target.value });
                                        }}
                                    />
                                    {this.state.isSubmitted && (filterName.trim() == undefined || this.state.filterName.trim() == null || this.state.filterName.trim() == "") && <ErrorComponent />}
                                </div>
                                <div className="col-sm-1 mt-3 pt-3">
                                    <FontAwesomeIcon
                                        icon={faThumbtack}
                                        color={isPinned ? "black" : "gray"}
                                        className={isPinned ? "black_rotate" : "gray_rotate"}
                                        onClick={() =>
                                            this.setState({
                                                isPinned: isPinned ? false : true,
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSaveAndClose}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save & Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreateNewReportSearch;